import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const token = localStorage.getItem('auth_token');
    if (token) {
      // Добавляем все необходимые заголовки как в curl
      const headers = {
        'Authorization': `Bearer ${token}`,
      };
      
      return next(req.clone({ setHeaders: headers }));
    }
  }
  return next(req);
};